import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import root from 'window-or-global';
import {connectToStores} from 'epic-alt-utils/index';
import Character from '../../components/character/Character';
import CharacterItem from '../../components/character/CharacterItem';
import SquareButton from '../../components/squareButton/SquareButton';
import Message from '../../components/message/Message';
import MetaTags from '../../components/common/MetaTags';
import {CharactersStore} from '../../stores';

const HEADWEAR = 'headwear';
const EYEWEAR = 'eyewear';
const MOBILE_TOGGLE = {
    OFF: 'off',
    INFO: 'info',
    ITEMS: 'items'
};

@connectToStores
export default class CharactersView extends React.Component {
    static getStores() {
        return [CharactersStore];
    }

    static getPropsFromStores() {
        return {
            charactersData: CharactersStore.getState()
        };
    }
    static propTypes = {
        charactersData: PropTypes.object,
        match: PropTypes.object
    };

    state = {
        characters: this.props.charactersData.data.lineup.characters,
        activeCharacter: 0,
        [HEADWEAR]: null,
        [EYEWEAR]: null,
        mobileToggle: MOBILE_TOGGLE.OFF
    }

    componentDidMount = () => {
        this.mergeProgressionLevelsToCharacters();
        this.getItemList(HEADWEAR);
        this.getItemList(EYEWEAR);
        this.matchHash();
    }

    mergeProgressionLevelsToCharacters = () => {
        const { data } = this.props.charactersData;
        const characters = data.lineup.characters.asMutable({deep:true});

        data.progression.levels.forEach(level => {
            if (!level.items || level.items.length === 0) return;
            level.items.forEach(item => {
                characters.forEach((character) => {
                    if (character.name !== item.character) return;
                    character.skins = Array.isArray(character.skins) ?
                        [...character.skins, item] :
                        [item];
                });
            });
        });
        this.setState({characters});
    }

    getItemList = (type) => {
        const { challenge, progression } = this.props.charactersData.data;
        const items = [];
        [progression, challenge].forEach(achievement => {
            achievement.levels.forEach(level => {
                if (!level.items || level.items.length === 0) return;
                level.items.forEach(item => {
                    if (item.type !== type) return;
                    items.push(item);
                });
            });
        })
        this.setState({ [type]: {items, active: -1} });
    }

    matchHash = () => {
        const hash = root.location.hash;
        if (!hash) return;
        this.state.characters.forEach((character, index) => {
            if (hash === `#${character.name}`) this.setState({ activeCharacter: index });
        })
    }

    prevCharacter = () => {
        const { characters, activeCharacter } = this.state;
        this.setState({
            activeCharacter: activeCharacter === 0 ? characters.length - 1 : activeCharacter - 1
        }, this.updateCurrentCharacter);
    }

    nextCharacter = () => {
        const { characters, activeCharacter } = this.state;
        this.setState({
            activeCharacter: activeCharacter === characters.length - 1 ? 0 : activeCharacter + 1
        }, this.updateCurrentCharacter);
    }

    updateCurrentCharacter = () => {
        const { characters, activeCharacter } = this.state;
        root.location.hash = `#${characters[activeCharacter].name}`;
        this.setState({
            [HEADWEAR]: { ...this.state[HEADWEAR], active: -1 },
            [EYEWEAR]: { ...this.state[EYEWEAR], active: -1 }
        });
    }

    renderItemList = type => {
        if (!this.state[type]) return null;
        const { items, active } = this.state[type];
        return (
            <>
            <h3 className="item-type"><Message code={`epic.ut.character.${type}`} /></h3>
            <ul className="item-list">
                { items.map((item, index) => (
                    <li key={item.name}>
                        <CharacterItem
                            active={index === active}
                            thumbnail={item.images[0].thumbnail}
                            name={item.name}
                            unlock={item.unlock}
                            onClick={() => this.setState({
                                [type]: {
                                    items,
                                    active: index === active ? -1 : index
                                },
                                mobileToggleItems: false
                            })} />
                    </li>
                )) }
            </ul>
            </>
        )
    }

    returnActiveItemImage = type => {
        if (!this.state[type]) return null;
        const { items, active } = this.state[type];
        if (!items[active]) return null;
        return items[active].images[0].image;
    }

    handleMobileToggle = toggle => {
        this.setState({
            mobileToggle: this.state.mobileToggle === toggle ?
                MOBILE_TOGGLE.OFF :
                toggle
        })
    }

    render() {
        const { _title } = this.props.charactersData.data;
        const {
            characters,
            activeCharacter,
            mobileToggle
        } = this.state;

        return (
            <div className="CharactersView">
                <MetaTags meta={{title: _title}} />
                <div className="characters-wrap">
                    {
                        characters.map((character, index) => (
                            <Character
                                key={character.name}
                                data={character}
                                active={activeCharacter === index}
                                mobileToggle={mobileToggle === MOBILE_TOGGLE.INFO}
                                headwear={this.returnActiveItemImage(HEADWEAR)}
                                eyewear={this.returnActiveItemImage(EYEWEAR)} />
                        ))
                    }
                    <div className="characters-nav-btns">
                        <SquareButton config={{arrow: 'left'}} handleClick={this.prevCharacter} />
                        <SquareButton config={{arrow: 'right'}} handleClick={this.nextCharacter} />
                    </div>
                </div>
                <div className={classNames('items-wrap', mobileToggle === MOBILE_TOGGLE.ITEMS && 'toggled')}>
                    { this.renderItemList(HEADWEAR) }
                    { this.renderItemList(EYEWEAR) }
                </div>
                <button
                    className="mobile-toggle-btn toggle-info"
                    onClick={() => this.handleMobileToggle(MOBILE_TOGGLE.INFO)}>
                    <i className="icon-user" />
                </button>
                <button
                    className="mobile-toggle-btn toggle-items"
                    onClick={() => this.handleMobileToggle(MOBILE_TOGGLE.ITEMS)}>
                    <i className="icon-params" />
                </button>
            </div>
        );
    }
}
